module.exports = __webpack_public_path__ + "media/application/images/partners/eu@2x-d76c2c5fafe7e64a71da92d2d6cc98eb9a39e33f6321a7399e9b0034ee44067a.png";